import { Col, DatePicker, Form, Input, Row, Button, InputNumber, Select } from 'antd'
import CustomSpin from '../../../../elements/CustomSpin'

import useFetchSelect from '../../../../elements/Hooks/useFetchSelect'
import CurrencySelect from '../../../../elements/Select/Currency'
import useFetch from '../../../../elements/Hooks/useFetch'
import CustomTable from '../../../../elements/Table/CustomTable'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'

import OrganisationsSelect from '../../../../elements/Select/Organistaions'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withSubDropdown from '../../../../elements/HOC/withSubDropdown'
import withSort from '../../../../elements/HOC/withSort'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import { compose } from 'recompose'

import { get, isEmpty } from 'lodash'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
} from '../../../../modules/FormItems'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
//import DateTimeCell from '../../../../elements/Table/Cells/DateCell'
import DateCell from '../../../../elements/Table/Cells/DateCell'

function RequestFundsForm(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form
  const { submitting, remiLines, setRemiLines } = props

  const { SelectData: LendersSelect, selected: _lender = {} } = useFetchSelect({
    url: 'lenders/',
  })

  const lender = getFieldValue('client._id') || ''
  const company = (getFieldValue('company._id') || '').replace('members/', '')

  const { SelectData: LendersContractSelect, selected: contract } = useFetchSelect({
    url: `lenders/${lender.replace('partners/', '')}/company/${company}/contracts/`,
    dontFetch: isEmpty(lender) || isEmpty(company),
    dependencyArray: [lender, company],
  })

  console.log(contract)
  const [isCurrency, setIsCurrency] = useState(false)
  useEffect(() => {
    if (get(contract, 'bank.currency')) {
      setFieldsValue({ currency: contract.bank.currency })
      setIsCurrency(true)
    } else {
      setIsCurrency(false)
    }
  }, [contract])

  const isLoanRequest = getFieldValue('requestType') === 'Loan Request'
  const isRemittanceReimbursement = getFieldValue('requestType') === 'Remittance Reimbursement'
  const isFundsReceivedForwarding = getFieldValue('requestType') === 'Funds Received Forwarding'

  const url = isRemittanceReimbursement
    ? `remittances/lines/${_lender._key}/${company}?currency=${getFieldValue('currency')}`
    : `receipts/lines/${_lender._key}/${company}?currency=${getFieldValue('currency')}`
  const { data, fetching, fetch } = useFetch({
    url,
    dependencyArray: [getFieldValue('requestType'), company, _lender._key, getFieldValue('currency')],
    dontFetch: isEmpty(company) || isEmpty(_lender._key) || isEmpty(getFieldValue('currency')),
  })

  console.log('Company:', company)

  React.useEffect(() => {
    if (data) {
      setRemiLines(data)
    } else {
      setRemiLines([{}])
    }
  }, [fetching])

  const [currencyVoucer, setCurrencyVoucer] = useState(true)

  const newColumns = isRemittanceReimbursement
   /* ? [
      {
        Header: 'Remittance',
        accessor: 'remittance.code',
      },
      {
        Header: 'Remittance Date',
        accessor: 'remittance.date',
        Cell: DateCell,
      },
      {
        Header: 'Paid From Currency',
        accessor: 'remittance.from.currency',
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Paid From Amount',
        accessor: 'remittance.from.amount',
        Cell: MoneyCell,
        //Footer: SumFooter,
        hideable: true,
        hideDefault: false,
      },
      {
        Header: 'Paid To Currency',
        accessor: 'remittance.to.currency',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'Paid To Amount',
        accessor: 'remittance.to.amount',
        Cell: MoneyCell,
        //Footer: SumFooter,
        hideable: true,
        hideDefault: false,
      },
        {
          Header: 'Voucher',
          accessor: 'voucher.code',
          //zIndex: -100,
        },
      {
        Header: 'Claim Date',
        accessor: 'voucher.billDate',
        Cell: DateCell,
        //zIndex: -95,
      },
      {
          Header: 'Vendor',
          accessor: 'voucher.payee.fn',
          hideable: true,
          hideDefault: false,
          //zIndex: -90,
       },
      {
        Header: 'Original Voucher Currency',
        accessor: 'voucher.originalCurrency',
        hideable: true,
        hideDefault: true,
      },
      {
        Header: 'RF Currency',
        accessor: currencyVoucer ? 'voucher.currency' : 'voucher.originalCurrency',
        hideable: true,
        hideDefault: false,
        //zIndex: -10,
      },
      {
        Header: 'RF Conversion',
        accessor: `voucher.conversion`,
        Cell: MoneyCell,
      },
      {
        Header: 'Converted Allocation',
        accessor: `${currencyVoucer ? 'voucher.taxSummary[0].allocation' : 'allocation'}`,
        Cell: MoneyCell,
        Footer: SumFooter,
        hideable: true,
        hideDefault: false,
      },
        {
          Header: 'Net',
          accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.net`,
          Cell: MoneyCell,
        },
        {
          Header: 'Gross',
          accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.gross`,
          Cell: MoneyCell,
        },
        {
          Header: 'Tax',
          accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.tax`,
          Cell: MoneyCell,
        },
        {
          Header: 'Declared',
          accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.declared`,
          Cell: MoneyCell,
        },
        {
          Header: 'Tax Type',
          accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher'}.type`,
        },
      ]*/
    ? [
        {
          Header: 'Remittance',
          columns: [
            {
              Header: 'Code',
              accessor: 'remittance.code',
            },
            {
              Header: 'Date',
              accessor: 'remittance.date',
              Cell: DateCell,
            },
            {
              Header: 'From CUR',
              accessor: 'remittance.from.currency',
              hideable: true,
              hideDefault: false,
            },
            {
              Header: 'From Amount',
              accessor: 'remittance.from.amount',
              Cell: MoneyCell,
              //Footer: SumFooter,
              hideable: true,
              hideDefault: false,
            },
            {
              Header: 'To CUR',
              accessor: 'remittance.to.currency',
              hideable: true,
              hideDefault: true,
            },
            {
              Header: 'To Amount',
              accessor: 'remittance.to.amount',
              Cell: MoneyCell,
              //Footer: SumFooter,
              hideable: true,
              hideDefault: false,
            },
          ],
        },
      {
        Header: 'Voucher',
        columns: [
          {
            Header: 'Code',
            accessor: 'voucher.code',
            //zIndex: -100,
          },
          {
            Header: 'Claim Date',
            accessor: 'voucher.billDate',
            Cell: DateCell,
            //zIndex: -95,
          },
          {
            Header: 'Vendor',
            accessor: 'voucher.payee.fn',
            hideable: true,
            hideDefault: false,
            //zIndex: -90,
          },
          /*{
            Header: 'Original Voucher Currency',
            accessor: 'voucher.originalCurrency',
            hideable: true,
            hideDefault: true,
          },*/
          {
            Header: 'RF CUR',
            accessor: currencyVoucer ? 'voucher.currency' : 'voucher.originalCurrency',
            hideable: true,
            hideDefault: false,
            //zIndex: -10,
          },
          {
            Header: 'RF Rate',
            accessor: `voucher.conversion`,
            Cell: MoneyCell,
          },
          {
            Header: 'RF Claim',
            accessor: `${currencyVoucer ? 'voucher.taxSummary[0].allocation' : 'allocation'}`,
            Cell: MoneyCell,
            Footer: SumFooter,
            hideable: true,
            hideDefault: false,
          },
          {
            Header: 'Net',
            accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.net`,
            Cell: MoneyCell,
          },
          {
            Header: 'Gross',
            accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.gross`,
            Cell: MoneyCell,
          },
          {
            Header: 'Tax',
            accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.tax`,
            Cell: MoneyCell,
          },
          {
            Header: 'Declared',
            accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher.originalTaxSummary'}.declared`,
            Cell: MoneyCell,
          },
          {
            Header: 'Tax Type',
            accessor: `${currencyVoucer ? 'voucher.taxSummary[0]' : 'voucher'}.type`,
          },
        ],
      }
      ]
    : [
        {
          Header: 'Receipt',
          accessor: 'receipt.code',
        },
        {
          Header: 'Client ',
          accessor: 'receipt.client.fn',
          hideable: true,
          hideDefault: false,
        },
        {
          Header: 'Invoice',
          accessor: 'invoice.code',
        },
        {
          Header: 'Currency',
          accessor: 'receipt.currency',
          hideable: true,
          hideDefault: false,
        },
        {
          Header: 'Receipt Amount',
          accessor: 'amount',
          Cell: MoneyCell,
          Footer: SumFooter,
        },
        {
          Header: 'Allocation',
          accessor: 'amount',
          Cell: MoneyCell,
          hideable: true,
          hideDefault: true,
        },
        {
          Header: 'Bank ',
          accessor: 'receipt.transaction.bank.lender.fn',
          hideable: true,
          hideDefault: false,
        },
        {
          Header: 'Account ',
          accessor: 'receipt.transaction.bank.bank.accountNumber',
          hideable: true,
          hideDefault: false,
        },
      ]

  let columns = [
    {
      Header: 'ID',
      accessor: '_id',
      hideable: true,
      hideDefault: true,
    },
    ...newColumns,
    {
      Header: 'Action',
      accessor: '_key',

      width: 90,
      Cell: ({ value, original }) => (
        <Button
          type="primary"
          size="small"
          onClick={() => {
            setRemiLines((e) => e.filter((e) => e._key !== value))
          }}>
          Remove
        </Button>
      ),
    },
  ]

  return (
    <CustomSpin spinning={submitting}>
      <Form>
        <Row>
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="Title">
              {getFieldDecorator('title', {
                rules: rules.input,
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Request Type'}>
              {getFieldDecorator('requestType', {
                rules: rules.select,
              })(<RequestType placeholder={'Request Type'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Purpose of Funds">
              {getFieldDecorator('description', {
                rules: rules.input,
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="From">
              {getFieldDecorator('company._id', {
                rules: rules.select,
              })(<OrganisationsSelect placeholder={'Select a Company'} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="To">
              {getFieldDecorator('client._id', {
                rules: rules.select,
              })(<LendersSelect valueAtr={'fn'} placeholder={'Select a Company'} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Finance Account">
              {getFieldDecorator('contract._id', {
                rules: rules.select,
              })(<LendersContractSelect valueAtr={'title'} placeholder={'Select a Company'} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="Currency">
              {getFieldDecorator('currency', {
                rules: rules.select,
              })(<CurrencySelect disabled={isCurrency} />)}
            </Form.Item>
          </Col>
          {isLoanRequest && (
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Amount">
                {getFieldDecorator('amount', {
                  rules: rules.input,
                })(<InputNumber />)}
              </Form.Item>
            </Col>
          )}
          <Col span={12}>
            <Form.Item {...threeFormItemLayout} label="Request Date">
              {getFieldDecorator('date', {
                rules: rules.input,
                initialValue: moment(),
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item {...threeFormItemLayout} label="Payment Due">
              {getFieldDecorator('dueDate', {
                rules: rules.input,
              })(<DatePicker style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        </Row>
        {(isRemittanceReimbursement || isFundsReceivedForwarding) && (
          <Row>
            <CustomTable
              {...{
                data: remiLines,
                CreateButton: () => (
                  <Select defaultValue={true} value={currencyVoucer} onChange={(e) => setCurrencyVoucer(e)}>
                    <Select.Option value={true}>Converted To Financial Account Currency</Select.Option>
                    <Select.Option value={false}>Show Original</Select.Option>
                  </Select>
                ),
                fetching,
                fetch,
                columns,
                isFilterable: true,
              }}
            />
          </Row>
        )}
      </Form>
    </CustomSpin>
  )
}

const RequestType = compose(
  withSelectFetch({
    dropdown: 'invoices',
    name: 'requestType',
  }),
  withSpinning,
  withSort
)(CustomSelect)

export default Form.create()(RequestFundsForm)
